module.exports = __webpack_public_path__ + "static/media/sns-icon-face.0f085926.svg";